<template>
 <div class="page t-container">
     <section class="t-mt-12 t-flex-col t-space-y-8 lg:t-space-y-0 lg:t-flex-row" role="main">
      <div class="t-flex t-flex-col t-space-y-8 lg:t-w-full lg:t-mr-8">
          <section class="dashboard-content t-flex-col t-rounded-md t-p-4 t-bg-white">
            <div style="border-bottom: 2px solid #EEEEEE;" class="t-pt-2 t-pb-4">
                <h3 class="t-text-xl t-font-bold">
                    DIFOT Report <span class="t-float-right">{{ datePeriod }}</span>
                </h3>
            </div>

            <difot-bar-chart
                v-if="loaded"
                :monthlabels="chartMonthLabels"
                :chartmonth="chartMonth"
            ></difot-bar-chart>
            <p v-else>Loading...</p>
        </section>

        <section class="dashboard-content t-flex-col t-rounded-md t-p-4 t-bg-white">
            <div style="border-bottom: 2px solid #EEEEEE;" class="t-pt-2 t-pb-4">
                <h3 class="t-text-xl t-font-bold">
                    % of Deliveries by Due Date - Last 12 months
                </h3>
            </div>

            <difot-line-chart
                v-if="loaded"
                :yearlabels="chartYearLabels" 
                :chartyear="chartYear"
            ></difot-line-chart>
            <p v-else>Loading...</p>
        </section>


        <section class="dashboard-content t-flex-col t-rounded-md t-p-4 t-bg-white">
            <div style="border-bottom: 2px solid #EEEEEE;" class="t-pt-2 t-pb-4">
                <h3 class="t-text-xl t-font-bold">
                     DIFOT Table Report <span class="t-float-right">{{ datePeriod }}</span>
                </h3>
            </div>

            <div class="t-py-2 t-px-2">
                <table class="table-auto" v-if="loaded">
                    <tbody>
                        <tr v-for="(label, index) in chartMonthLabels" :key="index">
                            <th class="t-py-2 t-px-1 t-w-1/6">{{ label }}</th>
                            <td class="w-full">
                                <div v-if="isArray(difotTableData[index])">
                                    <a v-for="(booking, idx) in difotTableData[index]" :key="idx" :href="Object.values(booking)[0]" target='_blank'>
                                        {{Object.keys(booking)[0]}}
                                    </a>
                                </div>       
                            </td>
                        </tr>
                    </tbody>
                </table>
                <p v-else>Loading...</p>
            </div>
        </section>
      </div>
    </section>
 </div>
</template>

<script>
import DifotLineChart from "./charts/DifotLineChart";
import DifotBarChart from "./charts/DifotBarChart";
import axios from "axios";

export default {
    components: {
        DifotLineChart,
        DifotBarChart
    },
    data() {
        return {
            loaded: false,
            datePeriod: '',
            chartMonthLabels: '',
            chartYearLabels: '',
            chartMonth: '',
            chartYear: '',
            difotTableData: '',
        }
    },
    mounted(){
        this.difotReport()
    },
    methods: {
        difotReport(){
            this.loaded = false;
            axios.get('/send-freight/bookings/difot/frontend')
            .then(response => {
                const { data } = response.data;
                this.datePeriod = data.datePeriod;
                this.chartMonthLabels = data.chartMonthLabels;
                this.chartYearLabels = data.chartYearLabels;
                this.chartMonth = JSON.parse(data.chartMonth);
                this.chartYear = JSON.parse(data.chartYear);
                this.difotTableData = data.difotTableData;
                this.loaded = true;
            })
            .catch(error => {
                console.error(error);
            })
        },
        isArray(array){
            return Array.isArray(array);
        }
    }
}
</script>

<style scoped>
tr:nth-child(even) {
    background-color: #fff;
}
tr:nth-child(odd) {
    background-color: rgb(219, 219, 219);
}
</style>
